<template>
<div>
    <div class="diagram-five-wrap" :style="{ height: winHeight - 100 + 'px' }" ref="total">
        <div id="main" ref="main" class="total-wrap">
            <div
                id="canvas"
                ref="canvas"
                class="canvas-wrap"
                :style="
                    `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                "
            >
                <img class="bg-img" src="../../../../assets/image/app/xbj-04.svg" alt srcset />
                <!-- <div class="total-title">MO1#变系统图</div> -->
                  <div
                        v-for="item in mo_datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @click="showDialog(item)"
                    >
                        <div class="data-item">
                            <div class="data-name red">ia</div>
                            <div class="data-number">
                                {{ item.ia }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name yellow">ib</div>
                            <div class="data-number">
                                {{ item.ib }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name green">ic</div>
                            <div class="data-number">
                                {{ item.ic }}
                                <span>A</span>
                            </div>
                        </div>
                    </div>
            
                    <div
                        v-for="item in mo_datas"
                        :key="item.switch_id"
                        class="top-switch"
                        :style="`top:${item._top}%;left:${item._left}%;`" @click="showTempDialog(item)"
                    >
                    <template v-if="item.isOn == 0">
                            <img
                               
                                src="../../../../assets/image/app/switch-on.svg"
                                alt
                                srcset
                                class="kaiguan"
                            />
                             </template>
                              <template v-else>
                                <img 
                                    src="../../../../assets/image/app/switch-off.svg"
                                    alt
                                    srcset
                                    class="kaiguan"
                                />
                            
                        </template>
                       
                    </div>
                    
            </div>
        </div>
         <diagramDialog :dialogVisible.sync="dialogVisible" :id="data_id" />
        <diagramDialog :dialogVisible.sync="dialogTempVisible" :id="switch_power_id" />
    </div>
</div>
</template>
<script>

import diagramDialog from "./components/diagram-dialog.vue";
import * as api from "@/http/api-runtime.js";
import { getNewestPower } from "@/http/api";
export default {
    components: { diagramDialog },
    data() {
        return {
           left: "0",
            top: "-20",
            scale: 0.9,
            width: 1200,
            height: 1000,
            winHeight: 0,
            dialogVisible: false,
            dialogTempVisible: false,
            data_id: "",
            data_temp_id: "",
            switch_power_id: "",
            timer: null,
                mo_datas: [
                {
                    name: "40Ga",
                    point_id: "1466658791549349888",
                     switch_id: "sunsu_000000000000022",
                    _top:60,
                    _left:4.2,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top: 88,
                    left:0,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "40Gb",
                    point_id: "1466665395447443456",
                    switch_id: "sunsu_000000000000023",
                    _top: 60,
                    _left:5,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top: 88,
                    left:6,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G01",
                    point_id: "1466665572392546304",
                    switch_id:"sunsu_000000000000024",
                     _top: 61.0,
                    _left:14.04,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top: 88,
                    left:12,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G02",
                    point_id: "1466665968511004672",
                    switch_id:"sunsu_000000000000025",
                     _top: 61,
                    _left:21.05,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top: 88,
                    left:19,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G03",
                    point_id: "1466666349131509760",
                    switch_id:"sunsu_000000000000026",
                    _top:61,
                    _left:28.03,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top: 88,
                    left:26,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G04",
                    point_id: "1466666582947180544",
                    switch_id:"sunsu_000000000000027",
                     _top:61,
                    _left:35.42,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:88,
                    left:33,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G05",
                    point_id: "1466666949554515968",
                    switch_id:"sunsu_000000000000028",
                    _top: 61,
                    _left:42.47,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:88,
                    left:40,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G06",
                    point_id: "1466667104806678528",
                    switch_id:"sunsu_000000000000029",
                    _top:61,
                    _left:49.65,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:88,
                    left:47,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G07",
                    point_id: "1466667249975734272",
                    switch_id:"sunsu_000000000000030",
                    _top:61,
                    _left:56.72,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:88,
                    left:55,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G08",
                    point_id: "1466667473746046976",
                    switch_id:"sunsu_000000000000031",
                    _top:61,
                    _left:63.72,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top: 88,
                    left: 62,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G09",
                    point_id: "1466667717053427712",
                    switch_id:"sunsu_000000000000032",
                    _top:61,
                    _left:71.56,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:88,
                    left: 69,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G10",
                    point_id: "1466667854869868544",
                    switch_id:"sunsu_000000000000033",
                    _top:61,
                    _left:79.07,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:88,
                    left:77,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G11",
                    point_id: "1466668278104502272",
                    switch_id:"sunsu_000000000000034",
                    _top:61,
                    _left:86.35,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:88,
                    left: 84,
                    ia: "",
                    ib: "",
                    ic: ""
                },
           
                 {
                    name: "4G12",
                    point_id: "1466668437408362496",
                    switch_id:"sunsu_000000000000035",
                     _top:61,
                    _left:93.77,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                  top:88,
                    left:91,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G13",
                    point_id: "1466668572364288000",
                    switch_id:"sunsu_000000000000036",
                     _top:14.5,
                    _left:93.10,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:92,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G14",
                    point_id: "1466668926984302592",
                    switch_id:"sunsu_000000000000037",
                     _top:14.5,
                    _left:86.67,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:84,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G15",
                    point_id: "1466669054289817600",
                    switch_id:"sunsu_000000000000038",
                     _top:14.5,
                    _left:79.90,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                   top:43,
                    left:78,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4G16",
                    point_id: "1466669159105474560",
                    switch_id:"sunsu_000000000000039",
                     _top:14.5,
                    _left:73.07,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                   top:43,
                    left:71,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G17",
                    point_id: "1466669282002776064",
                    switch_id:"sunsu_000000000000040",
                     _top:14.5,
                    _left:66.02,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                   top:43,
                    left:64,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                
                 {
                    name: "4G18",
                    point_id: "1466669415729770496",
                    switch_id:"sunsu_000000000000041",
                      _top:14.5,
                    _left:58.95,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:57,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G19",
                    point_id: "1466675477870587904",
                    switch_id:"sunsu_000000000000042",
                    _top:14.5,
                    _left:51.62,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                     left:50,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G20",
                    point_id: "1466675597538275328", 
                    switch_id:"sunsu_000000000000043",
                    _top:14.5,
                    _left:44.64,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                     top:43,
                    left:43,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G21",
                    point_id: "1466675784000253952",
                    switch_id:"sunsu_000000000000044",
                    _top:14.5,
                    _left:37.61,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:35,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G22",
                    point_id: "1466675902334152704",
                    switch_id:"sunsu_000000000000045",
                    _top:14.5,
                    _left:30.46,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:29,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G23",
                    point_id: "1466676022408687616",
                    switch_id:"sunsu_000000000000046",
                    _top:14.5,
                    _left:23.20,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:21,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G24",
                    point_id: "1466676268685635584",
                    switch_id:"sunsu_000000000000047",
                    _top:14.5,
                    _left:16.34,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:14,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G25",
                    point_id: "1466676381575327744",
                    switch_id:"sunsu_000000000000048",
                    _top:14.5,
                    _left:9.21,
                    isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:7,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4G26",
                    point_id: "1466676515168104448",
                    switch_id:"sunsu_000000000000049",
                    _top:14.5,
                    _left:2.34,
                   isOn:1,  //1默认连通  红色；  0断开  绿色
                    top:43,
                    left:1,
                    ia: "",
                    ib: "",
                    ic: ""
                },
            ]

        };
    },
    created() {
        if (window.innerHeight) this.winHeight = window.innerHeight;
        else if (document.body && document.body.clientHeight)
            this.winHeight = document.body.clientHeight;
    },

    mounted() {
        this.zoom();
        this.drag();
         this.setTimer();
        // 获取mo实时电数据
        this.getMoElecData();
        // 获取mo实时温度数据
       // this.getMoTempData();
        // 获取mo开关
        this.getWarnSwitch();
    },
     methods: {
          setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                // 获取mo实时电数据
                this.getMoElecData();
                // 获取mo实时温度数据
                // this.getMoTempData();
                
                
                 // 获取mo开关
                this.getWarnSwitch();
            }, 1000 * 60);
        },
        /**
        * @description: 获取mo实时电数据
        */
        getMoElecData() {
            let pointIds = [];
            this.mo_datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.mo_datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    item.ia = point && point["a_a"] && this.fixedString(point["a_a"], 2);
                    item.ib = point && point["a_b"] && this.fixedString(point["a_b"], 2);
                    item.ic = point && point["a_c"] && this.fixedString(point["a_c"], 2);
                })
            })
        },
                
        //开关开关
        getWarnSwitch() {
            let powerIds = [];
            this.mo_datas.forEach(item => {
                powerIds.push(item.switch_id);
            });
            api.getWarnSwitch(powerIds).then(res => {
                let valueJson = res.bus_json; 
                this.mo_datas.forEach(item => { 
                 let point = valueJson[item.switch_id];
                  item.isOn = point && point["kgl"];
                })
            })
        }, 
       
        /**
        * @description: 保留几位小数  number位数
        */
        fixedString(value, number) {
            let val = value + "";
            if (number == 0) {
                const arr = val.split(".");
                if (arr.length > 0) {
                    return arr[0];
                } else {
                    return "";
                }
            }
            return val.substring(0, val.indexOf(".") + (1 + number));

        },
        showDialog(item) {
            this.dialogVisible = true;
            this.data_id = item.point_id;
        },
        showTempDialog(item) {
            this.dialogTempVisible = true;
            this.switch_power_id = item.switch_id;  
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        },
    },
       destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.diagram-five-wrap {
    background-color: #09292f;
    width: 98%;
    overflow: hidden;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    .total-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: move;
        .canvas-wrap {
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
              box-sizing: border-box;
                  .bg-img {
                    width: 100%;
                    height: 100%;
                }
        }
                .top-switch {
               cursor: pointer;
                transform: scale(1);
                position: absolute;
                text-align: center;
                display: flex;
                //height: 20%;
                overflow: hidden;

                .top-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }
        .total-title {
            color: #fff;
            position: absolute;
            font-size: 24px;
            text-align: center;
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
        }
        .bg-img {
            width: 100%;
        }

        .data-wrap {
            position: absolute;
            display: grid;
            transform: scale(1);
            cursor: pointer;

            .data-item {
                display: flex;
                margin-bottom: 0.2rem;

                .data-name {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }

                .data-number {
                    font-size: 0.8rem;
                    width: 4.7rem;
                    text-align: right;
                     background-color: #0e4b69;
                    color: #fff;
                    height: 1rem;
                    line-height: 1rem;
                 // margin-left: 0.4rem;
                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
            .data-item-temp {
                display: flex;
                margin-bottom: 0.3rem;

                .data-name-temp {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }
             
                .data-number-temp {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                    // background-color: #114aa5;
                    color: #fff;
                    height: 1.2rem;
                    line-height: 1.2rem;

                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
        }
    }
}
</style>
